/**
 * @ngdoc service
 * @name picklists.factory:Picklist
 *
 * @description
 *
 */
angular
    .module('festzelt-os.modules.bo')
    .factory('BoOption', [
        'locale',
        'Resource',
        BoOption
    ]);

function BoOption(locale, Resource) {
    return Resource.make('bo/options');
}



// WEBPACK FOOTER //
// ./src/app/modules/bo/options/factories/option-factory.js